<template>
  <div class="me">
    <multiselect
      v-model="internalSelected"
      :options="options"
      :multiple="true"
      :taggable="true"
      :placeholder="multiPlaceholder"
      tag-placeholder="Наберите и нажмите Enter"
      select-label="Нажмите Enter, чтобы добавить"
      deselect-label="Нажмите Enter, чтобы удалить"
      @tag="addOption"
      label="name"
      track-by="name"
      :noResult="() => 'Не найдено опций'"
      :noOptions="() => {return 'Список пуст'}"
      :searchable="true"
      :close-on-select="false"
      :close-on-click-outside="false"
      class="multiselect-light"
      :showNoOptions="false"
      :hide-selected="true"
    >
    	<template #noResult>
        <span>Элементы не найдены</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'MultiselectLight',
  components: { Multiselect },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    multiPlaceholder: {
    	type: String,
    	default: ''
    }
  },
  data() {
    return {
      options: [],
      selectedOptions: []
    };
  },
  computed: {
    internalSelected: {
      get() {
        return this.selectedOptions;
      },
      set(val) {
        this.selectedOptions = val.filter(item => item && item.name); // Только объекты
        this.updateResult();
      }
    }
  },
  methods: {
    addOption(newOption) {
      const option = { name: newOption };
      this.options.push(option);
      this.selectedOptions.push(option);
      this.updateResult();
    },
    updateResult() {
      const result = this.selectedOptions.map(item => item.name).join(',');
      this.$emit('update:modelValue', result);
    }
  }
};
</script>



<style scoped>
.me {
  width: 100%;
}

:deep(.multiselect-light .multiselect) {
  background: #ffffff !important;
  border: 1px solid #e6e9ee !important;
  color: #0f1724 !important;
  border-radius: 8px !important;
}

:deep(.multiselect-light .multiselect__input) {
  color: #0f1724 !important;
}

:deep(.multiselect-light .multiselect__placeholder) {
  color: #6b7280 !important;
}

:deep(.multiselect-light .multiselect__tags) {

}

:deep(.multiselect-light .multiselect__tag) {
  background: rgba(37,99,235,0.12) !important;
  border: 1px solid rgba(37,99,235,0.25) !important;
  color: #2563eb !important;
  border-radius: 6px;
  padding: 2px 6px;
	display: flex;
	font-size: 1rem;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
	width: fit-content;
}

:deep(.multiselect__content-wrapper) {
	background: transparent !important
}

:deep(.multiselect-light .multiselect__tag span) {
	padding-right: 1rem;
}
:deep(.multiselect-light .multiselect__tag-icon) {
  color: #2563eb !important;
	line-height: 1.1;
}

:deep(.multiselect-light .multiselect__option) {
  background: #ffffff !important;
  color: #0f1724 !important;
  padding: 8px 12px;
}

:deep(.multiselect-light .multiselect__option--highlight) {
  background: #eef2ff !important;
}

:deep(.multiselect-light .multiselect__option--selected) {
  background: rgba(37,99,235,0.1) !important;
  color: #2563eb !important;
}

:deep(.multiselect-light .multiselect__noResult),
:deep(.multiselect-light .multiselect__noOptions) {
  color: #6b7280 !important;
  padding: 8px 12px;
}

@media (max-width: 350px) {
  .me { width: 100%; }
}

:deep(.multiselect__element span) {
	background: transparent !important;
	color: black !important;
}
:deep(.multiselect-light .multiselect__input) {
	background: transparent !important;
	color: black !important;
}
</style>
